import { useEffect, useState } from "react";
import { api, reLoadPage, token } from "../services/config";
import PaginationBill from "../components/PaginationBill";

export const Help = () => {
  const [loading, setLoading] = useState(true);
  const [allExcel, setAllExcel] = useState([]);
  const [pageCount, setPageCount] = useState(1);
  const [meta, setMeta] = useState({});
  const [isDark, setIsDark] = useState(
    () =>
      typeof window !== "undefined" && document.body.classList.contains("dark")
  );
  useEffect(() => {
    const checkDark = () => setIsDark(document.body.classList.contains("dark"));
    checkDark();
    const observer = new MutationObserver(() => {
      checkDark();
    });
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });
    return () => {
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await api.get(`/excel-exports?page=${pageCount}`, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            authorization: `Bearer ${localStorage.getItem("login")}`,
          },
        });
        setAllExcel(response.data.data);
        setMeta(response.data.meta || {});
        console.log(response.data.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [pageCount]);

  // تابع برای نمایش وضعیت
  const getStatusLabel = (status) => {
    return status === 100 ? "موفق" : "ناموفق";
  };

  const handleDownload = async (id) => {
    try {
      const response = await api.get(`/excel-exports/${id}/download`, {
        responseType: "blob",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          authorization: `Bearer ${localStorage.getItem("login")}`,
        },
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `file-${id}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      setTimeout(() => window.URL.revokeObjectURL(url), 100);
    } catch (error) {
      console.error("خطا در دانلود فایل:", error);
    }
  };

  return (
    <div className="w-full h-screen bg-white dark:bg-[#0D1117]">
      <div className="mb-6 p-3 lg:p-6">
        <h1
          className="
    relative inline-block text-3xl font-bold mb-6 
    text-[#0010c6] dark:text-white
    after:content-[''] after:block after:w-full after:h-[4px] 
    after:bg-[#0010c6] after:mt-[10px] dark:after:bg-[#ffffff]
  "
        >
          مشاهده اکسل ها
        </h1>
      </div>

      <div className="w-[95%] md:w-[80%] mx-auto">
        {loading ? (
          <div className="text-center py-8">در حال بارگذاری...</div>
        ) : allExcel.length > 0 ? (
          <div className="overflow-x-auto rounded-lg shadow bg-white dark:bg-[#161B22]">
            <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
              {/* ---- header ---- */}
              <thead className="bg-[#E8F0FE] dark:bg-[#1E2329]">
                <tr>
                  <th className="px-6 py-5 text-right text-xs font-medium text-gray-600 dark:text-gray-300 uppercase tracking-wider">
                     آیدی
                  </th>
                  <th className="px-6 py-5 text-right text-xs font-medium text-gray-600 dark:text-gray-300 uppercase tracking-wider">
                    تاریخ ایجاد
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-600 dark:text-gray-300 uppercase tracking-wider">
                    وضعیت
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-600 dark:text-gray-300 uppercase tracking-wider">
                    از محل
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-600 dark:text-gray-300 uppercase tracking-wider">
                    دانلود
                  </th>
                </tr>
              </thead>

              {/* ---- body ---- */}
              <tbody>
                {allExcel.map((item, index) => (
                  <tr
                    key={item.id}
                    className={`${
                      index % 2 === 0
                        ? "bg-white dark:bg-[#1E2329]" // زوج
                        : "bg-[#eaf3fc] dark:bg-[#161B22]" // فرد
                    }`}
                  >
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-gray-200">
                      {item?.id}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-gray-200">
                      {new Date(item.created_at).toLocaleString("fa-IR")}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm">
                      <span
                        className={`px-2 py-1 rounded-full text-xs font-semibold ${
                          item.status === 100
                            ? "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200"
                            : "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200"
                        }`}
                      >
                        {item?.status_label}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm">
                      {item?.type_label}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm">
                      <button
                        onClick={() => handleDownload(item.id)}
                        className="px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors text-xs"
                      >
                        دانلود فایل
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="text-center py-8 text-gray-500 dark:text-gray-400">
            هیچ داده‌ای برای نمایش وجود ندارد
          </div>
        )}
      </div>
      <div style={{ width: "100%", height: "200px" }}>
        <PaginationBill
          meta={meta}
          pageCount={pageCount}
          setPageCount={setPageCount}
          setLoading={setLoading}
          isDark={isDark}
        />
      </div>
    </div>
  );
};
